/* Elements Start */
// Main Elements
import GRow from './elements/GRow';
import Heading from './elements/Text';
import Slider from './elements/Slider';
import CatsList from './elements/CatsList';
import ProductsList from './elements/NewProductListTemplate';
import Image from './elements/ImageNew';
import Video from './elements/Video';
import FAIcon from './elements/FAIcon';
import Link from './elements/Link';
import List from './elements/List';
import Subscribe from './elements/Subscribe';
import FBCheckbox from './elements/FBCheckbox';
import HtmlCode from './elements/HtmlCode';
import Divider from './elements/Divider';
import CollapseHeading from './elements/Collapse';
import Tabs from './elements/Tabs';

// Product Page
import ProductPictures from './elements/Product/Pictures';
import ProductTitle from './elements/Product/Title';
import ProductDescription from './elements/Product/Description';
import ProductPricing from './elements/Product/Pricing';
import ProductStockCountdown from './elements/Product/StockCountdown';
import ProductCountdownTimer from './elements/Product/CountdownTimer';
import ProductAddToCart from './elements/Product/AddToCart';
import ProductInstantCheckout from './elements/Product/InstantCheckout';
import ProductQuantity from './elements/Product/Quantity';
import ProductQuantityDiscounts from './elements/Product/QuantityDiscounts';
import ProductAttributes from './elements/Product/Attributes';
import ProductViewers from './elements/Product/Viewers';
import ProductReviews from './elements/Product/Reviews';
import ProductBump from './elements/Product/Bump';
import ProductBundle from './elements/Product/Bundle';
import RelatedProducts from './elements/Product/NewProducts';

import ProductUpsellDescription from './elements/Upsell/Description';
import ProductUpsellTotalCartPrice from './elements/Upsell/TotalCartPrice';

import Summary from './elements/Shoppingcart/Summary';
import FlyoutCartSummary from './elements/FlyoutCart/Summary';

// Category Page
import CategoryTitle from './elements/Category/Title';
import CategoryImage from './elements/Category/Image';
import CategoryDescription from './elements/Category/Description';
import CategoryProducts from './elements/Category/NewProducts';

// Brand Pages
import BrandTitle from './elements/Brand/Title';
import BrandImage from './elements/Brand/Image';
import BrandDescription from './elements/Brand/Description';
import BrandProducts from './elements/Brand/NewProducts';

// Checkout Page
import CheckoutForm from './elements/Checkout/Form';
import CheckoutSteps from './elements/Checkout/Steps';
import CheckoutSummary from './elements/Checkout/Summary';
/* Elements End */

const leftPalettes = [
  {
    title: "Blocks",
    sideTitle: "Blocks",
    id: "blocks",
    icon: "blocks",
    tabs: [],
  },
  {
    title: "Add New",
    sideTitle: "Add New",
    id: "addnew",
    icon: "plus-menu",
  },
  {
    title: "Elements",
    sideTitle: "Elements",
    id: "elements",
    icon: "elements",
    tabs: [
      {
        title: "Global Elements",
        id: "global",
        groups: [
          {
            title: "Layouts",
            items: [
              {
                name: "1 Column",
                icon: ["fal", "columns"],
                id: "grow-1",
                type: "row",
                component: GRow,
                options: {
                  icon: ["fal", "columns"],
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                  },
                  payload: {
                    fullContainer: false,
                    newRow: true,
                    settings: {
                      spacing: {
                        marginTop: 15,
                        marginBottom: 15,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    columns: {
                      xl: [12],
                      lg: [12],
                      md: [12],
                      sm: [12],
                      xs: [12],
                    },
                    datas: {},
                  },
                },
              },
              {
                name: "2 Columns",
                icon: ["fal", "columns"],
                id: "grow-2",
                type: "row",
                component: GRow,
                options: {
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                  },
                  payload: {
                    fullContainer: false,
                    newRow: true,
                    settings: {
                      spacing: {
                        marginTop: 15,
                        marginBottom: 15,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    columns: {
                      xl: [6, 6],
                      lg: [6, 6],
                      md: [6, 6],
                      sm: [12, 12],
                      xs: [12, 12],
                    },
                    datas: {},
                  },
                },
              },
              {
                name: "3 Columns",
                icon: ["fal", "columns"],
                id: "grow-3",
                type: "row",
                component: GRow,
                options: {
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                  },
                  payload: {
                    fullContainer: false,
                    newRow: true,
                    settings: {
                      spacing: {
                        marginTop: 15,
                        marginBottom: 15,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    columns: {
                      xl: [4, 4, 4],
                      lg: [4, 4, 4],
                      md: [4, 4, 4],
                      sm: [12, 12, 12],
                      xs: [12, 12, 12],
                    },
                    datas: {},
                  },
                },
              },
              {
                name: "4 Columns",
                icon: ["fal", "columns"],
                id: "grow-4",
                type: "row",
                component: GRow,
                options: {
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                  },
                  payload: {
                    fullContainer: false,
                    newRow: true,
                    settings: {
                      spacing: {
                        marginTop: 15,
                        marginBottom: 15,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    columns: {
                      xl: [3, 3, 3, 3],
                      lg: [3, 3, 3, 3],
                      md: [3, 3, 3, 3],
                      sm: [12, 12, 12, 12],
                      xs: [12, 12, 12, 12],
                    },
                    datas: {},
                  },
                },
              },
              {
                name: "5 Columns",
                icon: ["fal", "columns"],
                id: "grow-5",
                type: "row",
                component: GRow,
                options: {
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                  },
                  payload: {
                    fullContainer: false,
                    newRow: true,
                    settings: {
                      spacing: {
                        marginTop: 15,
                        marginBottom: 15,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    columns: {
                      xl: [3, 3, 2, 2, 2],
                      lg: [3, 3, 2, 2, 2],
                      md: [3, 3, 2, 2, 2],
                      sm: [12, 12, 12, 12, 12],
                      xs: [12, 12, 12, 12, 12],
                    },
                    datas: {},
                  },
                },
              },
              {
                name: "6 Columns",
                icon: ["fal", "columns"],
                id: "grow-6",
                type: "row",
                component: GRow,
                options: {
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                  },
                  payload: {
                    fullContainer: false,
                    newRow: true,
                    settings: {
                      spacing: {
                        marginTop: 15,
                        marginBottom: 15,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    columns: {
                      xl: [2, 2, 2, 2, 2, 2],
                      lg: [2, 2, 2, 2, 2, 2],
                      md: [2, 2, 2, 2, 2, 2],
                      sm: [12, 12, 12, 12, 12, 12],
                      xs: [12, 12, 12, 12, 12, 12],
                    },
                    datas: {},
                  },
                },
              },
              {
                name: "Divider",
                icon: "dashed-line",
                id: "divider",
                type: "divider",
                component: Divider,
                options: {
                  settings: {
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: false,
                    spacing: true,
                    corners: true,
                    text: false,
                    dividerSettings: true,
                  },
                  payload: {
                    fullContainer: true,
                    settings: {
                      divider: {
                        dividerLineColor: "rgba(0,0,0,1)",
                        dividerLineType: "dashed",
                        dividerLineWidth: 4,
                        dividerSpacingBottom: 10,
                        dividerSpacingTop: 10,
                      },
                    },
                    datas: {},
                  },
                },
              },
              {
                name: "Tabs",
                icon: "tabs",
                id: "tabs",
                type: "tabs",
                component: Tabs,
                options: {
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    tabsSettings: {
                      activeTabColor: true,
                      tabColor: true,
                      tabTextColor: true,
                      activeTabTextColor: true,
                    },
                    tabsStyle: true,
                  },
                  payload: {
                    fullContainer: false,
                    newRow: true,
                    settings: {
                      tabHead: {},
                      spacing: {
                        marginTop: 15,
                        marginBottom: 15,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      tabBackground: { backgroundColor: "" },
                      contentBorder: {
                        border_target: "border",
                        border_width: 1,
                        border_color: "rgba(53,89,197,1)",
                        border_style: "solid",
                      },
                      activeTabFont: {
                        fontSize: 14,
                        color: "rgba(255,255,255,1)",
                      },
                      tabSpacing: {
                        paddingTop: 10,
                        paddingBottom: 10,
                        paddingLeft: 25,
                        paddingRight: 25,
                      },
                      inactiveTabFont: {
                        fontSize: 14,
                        color: "rgba(53,89,197,1)",
                      },
                      inactiveTabBorder: {
                        border_style: null,
                        border_target: "border",
                        border_width: 1,
                        border_color: "rgba(53,89,197,1)",
                        lt: 4,
                        rt: 4,
                      },
                      inactiveTabBackground: {
                        backgroundColor: "rgba(255,255,255,1)",
                      },
                      activeTabBorder: {
                        lt: 4,
                        rt: 4,
                        border_style: "solid",
                        border_target: "border",
                        border_width: 1,
                        border_color: "rgba(53,89,197,1)",
                      },
                      activeTabBackground: {
                        backgroundColor: "rgba(53,89,197,1)",
                      },
                    },

                    datas: {
                      tabs: [
                        {
                          id: Math.floor(Math.random() * 10000 + 1).toString(),
                          data: {
                            title_1: "Tab 1",
                          },
                          rank: 1,
                        },
                        {
                          id: Math.floor(Math.random() * 10000 + 1).toString(),
                          data: {
                            title_1: "Tab 2",
                          },
                          rank: 2,
                        },
                      ],
                    },
                  },
                },
              },
            ],
          },
          {
            title: "Text",
            items: [
              {
                name: "H1",
                subName: "Heading",
                icon: "h1",
                id: "h1",
                type: "text",
                component: Heading,
                options: {
                  icon: ["fal", "h1"],
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                  },
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        textAlign: "center",
                      },
                    },
                    dummyContent: "<h1>Your custom title</h1>",
                    content: {
                      1: "<h1>Your custom title</h1>",
                    },
                    datas: {},
                  },
                },
              },
              {
                name: "H2",
                subName: "SubHeading",
                icon: "h2",
                id: "h2",
                type: "text",
                component: Heading,
                options: {
                  icon: ["fal", "h2"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        textAlign: "center",
                      },
                    },
                    dummyContent: "<h2>Your custom title</h2>",
                    content: {
                      1: "<h2>Your custom title</h2>",
                    },
                    datas: {},
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                  },
                },
              },
              {
                name: "H3",
                subName: "Title",
                icon: "h3",
                id: "h3",
                type: "text",
                component: Heading,
                options: {
                  icon: ["fal", "h3"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        textAlign: "center",
                      },
                    },
                    dummyContent: "<h3>Your custom title</h3>",
                    content: {
                      1: "<h3>Your custom title</h3>",
                    },
                    datas: {},
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                  },
                },
              },
              {
                name: "H4",
                subName: "Sub Title",
                icon: "h4",
                id: "h4",
                type: "text",
                component: Heading,
                options: {
                  icon: ["fal", "h4"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        textAlign: "center",
                      },
                    },
                    dummyContent: "<h4>Your custom title</h4>",
                    content: {
                      1: "<h4>Your custom title</h4>",
                    },
                    datas: {},
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                  },
                },
              },
              {
                name: "H5",
                icon: "h5",
                id: "h5",
                type: "text",
                component: Heading,
                options: {
                  icon: ["fal", "h4"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        textAlign: "center",
                      },
                    },
                    dummyContent: "<h5>Your custom title</h5>",
                    content: {
                      1: "<h5>Your custom title</h5>",
                    },
                    datas: {},
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                  },
                },
              },
              {
                name: "H6",
                icon: "h6",
                id: "h6",
                type: "text",
                component: Heading,
                options: {
                  icon: ["fal", "h4"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        textAlign: "center",
                      },
                    },
                    dummyContent: "<h6>Your custom title</h6>",
                    content: {
                      1: "<h6>Your custom title</h6>",
                    },
                    datas: {},
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                  },
                },
              },
              {
                name: "Paragraph",
                icon: "paragraph",
                id: "p",
                type: "text",
                component: Heading,
                options: {
                  icon: ["fal", "align-left"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        textAlign: "center",
                      },
                    },
                    dummyContent:
                      "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eget pellentesque orci. Curabitur diam nulla, rutrum aliquam mi vel, porttitor facilisis ipsum. Nunc vestibulum justo id ipsum dignissim, non suscipit enim consectetur. Sed dui eros, sollicitudin et dolor ac, vehicula congue lectus. Pellentesque ullamcorper, magna at interdum dapibus, ipsum libero viverra erat, non rutrum ipsum dolor sit amet nisl. Nulla lacinia rhoncus est a finibus. Duis nulla purus, sodales ac dapibus ut, tempor dapibus dui. Ut tristique erat a euismod efficitur. Nullam et luctus risus. Aenean sit amet mauris quis sem cursus dictum at ac nisi. Praesent vel ante luctus, aliquam velit sed, bibendum urna. Maecenas at tellus imperdiet, placerat magna id, tincidunt velit. Integer lobortis facilisis urna sed iaculis.</p>",
                    content: {
                      1: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eget pellentesque orci. Curabitur diam nulla, rutrum aliquam mi vel, porttitor facilisis ipsum. Nunc vestibulum justo id ipsum dignissim, non suscipit enim consectetur. Sed dui eros, sollicitudin et dolor ac, vehicula congue lectus. Pellentesque ullamcorper, magna at interdum dapibus, ipsum libero viverra erat, non rutrum ipsum dolor sit amet nisl. Nulla lacinia rhoncus est a finibus. Duis nulla purus, sodales ac dapibus ut, tempor dapibus dui. Ut tristique erat a euismod efficitur. Nullam et luctus risus. Aenean sit amet mauris quis sem cursus dictum at ac nisi. Praesent vel ante luctus, aliquam velit sed, bibendum urna. Maecenas at tellus imperdiet, placerat magna id, tincidunt velit. Integer lobortis facilisis urna sed iaculis.</p>",
                    },
                    datas: {},
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                  },
                },
              },
              {
                name: "Collapse",
                icon: "collapse",
                id: "collapse_heading",
                type: "collapse_heading",
                component: CollapseHeading,
                options: {
                  icon: ["fal", "align-left"],
                  payload: {
                    fullContainer: false,
                    settings: {
                      spacing: {},
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: { textAlign: "left", color: "rgba(255,255,255,1)" },
                      tabBackground: { backgroundColor: "rgba(53,89,197,1)" },
                      tabSpacing: {
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 25,
                        paddingRight: 25,
                      },
                      contentBorder: {
                        border_target: "border",
                        border_width: 1,
                        border_color: "rgba(53,89,197,1)",
                        border_style: "solid",
                      },
                    },
                    datas: {
                      animationStyle: "ease",
                      animationTime: 1,
                      headingTag: "h4",
                      headingText: "+ Read More ",
                      collapseOpen: 1,
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                    collapseSettings: true,
                  },
                },
              },
            ],
          },
          {
            title: "Media",
            items: [
              {
                name: "Slider",
                icon: ["fal", "images"],
                id: "slider",
                type: "slider",
                component: Slider,
                options: {
                  icon: ["fal", "images"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      sliderSettings: {
                        autoheight: true,
                      },
                    },
                    datas: {
                      sliderSettings: {
                        autoheight: true,
                      },
                      titleTag: "h3",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: false,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    sliderItems: true,
                    sliderSettings: true,
                    sliderTextSettings: true,
                    sliderLinkSettings: true,
                  },
                },
              },
              {
                name: "Carousel",
                icon: ["fal", "images"],
                id: "carousel",
                type: "slider",
                component: Slider,
                options: {
                  icon: ["fal", "images"],
                  carousel: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      sliderSettings: {
                        autoheight: true,
                      },
                    },
                    datas: {
                      sliderSettings: {
                        item_count_desktop: 4,
                        item_count_tab: 2,
                        item_count_mobile: 1,
                        item_spacing_desktop: 10,
                        item_spacing_tab: 5,
                        item_spacing_mobile: 5,
                        autoheight: true,
                      },
                      titleTag: "h3",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    // text: {
                    //   color: true,
                    //   textAlign: true,
                    //   fontFamily: true,
                    //   fontSize: true,
                    //   letterSpacing: true,
                    //   lineHeight: false,
                    // },
                    sliderItems: true,
                    sliderSettings: true,
                    carouselSettings: true,
                    sliderTextSettings: true,
                    sliderLinkSettings: true,
                    productTitleSettings: true,
                  },
                },
              },
              {
                name: "Image",
                icon: ["fal", "image"],
                id: "image",
                type: "image",
                component: Image,
                options: {
                  icon: ["fal", "image"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        // marginBottom: 10,
                      },
                      alignment: "center",
                    },
                    datas: {
                      // imageHeight: 200,
                      imageWidth: 200,
                      displayMode: "ratio",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: false,
                    imageSettings: true,
                    imageUpload: true,
                    linkSettings: true,
                    overlayText: true,
                  },
                },
              },
              {
                name: "Video",
                icon: ["fal", "play-circle"],
                id: "video",
                type: "video",
                component: Video,
                options: {
                  icon: ["fal", "play-circle"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: false,
                    text: false,
                    videoDimensions: true,
                    videoSource: true,
                  },
                },
              },
              {
                name: "Icon",
                icon: ["fal", "icons"],
                id: "faicon",
                type: "faicon",
                component: FAIcon,
                options: {
                  icon: ["fal", "icons"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginTop: 10,
                        marginBottom: 10,
                        marginLeft: 10,
                        marginRight: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      alignment: "center",
                      text: {
                        fontSize: 33,
                      },
                    },
                    datas: {},
                  },
                  settings: {
                    // Settings capability
                    opacity: false,
                    background: true,
                    text: {
                      title: "Icon Style",
                      color: true,
                      textAlign: false,
                      fontFamily: false,
                      fontSize: true,
                      letterSpacing: false,
                      lineHeight: true,
                    },
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    fontAwesomeIcon: true,
                  },
                },
              },
              {
                name: "Store logo",
                icon: ["fal", "image"],
                id: "store-image",
                type: "image",
                component: Image,
                options: {
                  icon: ["fal", "image"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      alignment: "center",
                    },
                    datas: {
                      imageHeight: 200,
                      imageWidth: 200,
                      storeLogo: true,
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: false,
                    imageSettings: true,
                    imageUpload: false,
                    linkSettings: true,
                  },
                },
              },
            ],
          },
          {
            title: "Products / Categories",
            items: [
              {
                name: "Categories List",
                icon: ["fal", "folders"],
                id: "catslist",
                type: "catslist",
                component: CatsList,
                options: {
                  icon: ["fal", "folders"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      catsPerRowLg: 3,
                      catsPerRowMd: 4,
                      catsPerRowSm: 4,
                      catsPerRowXs: 6,
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                    catListsSettings: true,
                    globalSettings: ["PS_CATEGORY_GLOBAL_SETTING"],
                  },
                },
              },
              {
                name: "Products List",
                icon: ["fal", "shopping-bag"],
                id: "productslist",
                type: "productslist",
                component: ProductsList,
                options: {
                  icon: ["fal", "shopping-bag"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      priceStyles: {},
                    },
                    datas: {
                      productsPerRowLg: 3,
                      productsPerRowMd: 4,
                      productsPerRowSm: 4,
                      productsPerRowXs: 6,
                      atclabel: "Add to cart",
                      // atcbc: "#33862d",
                      // atcc: "#ffffff",
                      titleTag: "h4",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    // text: false,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productsList: true,
                    atcStyling: true,
                    priceStyle: true,
                    imageCss: true,
                    starStyle: true,
                  },
                },
              },
            ],
          },
          {
            title: "Content",
            items: [
              {
                name: "Link",
                icon: ["fal", "link"],
                id: "link",
                type: "link",
                component: Link,
                options: {
                  icon: ["fal", "link"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      linkLabel_1: "Click here",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    linkSettings: true,
                    labelSettings: true,
                    iconSettings: true,
                  },
                },
              },
              {
                name: "List",
                icon: ["fal", "list"],
                id: "list",
                type: "list",
                component: List,
                options: {
                  icon: ["fal", "list"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      alignment: "center",
                      text: {
                        textAlign: "center",
                      },
                    },
                    datas: {
                      alignment: "center",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                    listSettings: true,
                    iconSettings: true,
                    inlineSettings: true,
                  },
                },
              },
              {
                name: "Subscribe",
                icon: ["fal", "envelope-open-text"],
                id: "subscribe",
                type: "subscribe",
                component: Subscribe,
                options: {
                  icon: ["fal", "envelope-open-text"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      newsletterSettings: {
                        buttonIconPosition: "left",
                        btnColor: "#fff",
                        btnBackground: "rgb(47, 134, 45)",
                      },
                      viewSettings: {
                        showInline: true,
                      },
                    },
                    datas: {
                      newsletterSettings: {
                        flPlaceholder_1: "Enter your email...",
                        btnLabel_1: "Subscribe",
                        useButtonIcon: false,
                        buttonIconPosition: "left",
                        btnColor: "#fff",
                        btnBackground: "rgb(47, 134, 45)",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: false,
                    newsletterFieldBackgroundSettings: true,
                    newsletterFieldTextSettings: true,
                    newsletterFieldBorderSettings: true,
                    newsletterFieldCornerSettings: true,
                    newsletterButtonBackgroundSettings: true,
                    newsletterButtonTextSettings: true,
                    newsletterButtonLabelSettings: true,
                    newsletterButtonBorderSettings: true,
                    newsletterButtonCornerSettings: true,
                  },
                },
              },
              {
                name: "Testimonials",
                icon: ["fal", "user"],
                id: "testimonials",
                type: "slider",
                component: Slider,
                options: {
                  icon: ["fal", "user"],
                  testimonial: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      titleTag: "h2",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: false,
                    sliderItems: true,
                    sliderTextSettings: true,
                    sliderTestimonialSettings: true,
                  },
                },
              },
              {
                name: "Html Code",
                icon: ["fal", "code"],
                id: "html_code",
                type: "html_code",
                component: HtmlCode,
                options: {
                  icon: ["fal", "code"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: false,
                    text: false,
                    htmlCode: true,
                  },
                },
              },
            ],
          },
          {
            title: "Buttons",
            items: [
              {
                name: "Button",
                icon: ["fal", "rectangle-landscape"],
                id: "button_15",
                type: "link",
                component: Link,
                options: {
                  icon: ["fal", "rectangle-landscape"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      linkLabel: "Regular Button",
                      type: "regular",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    linkSettings: true,
                    buttonlabelSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Button",
                icon: ["fal", "rectangle-landscape"],
                id: "button_14",
                type: "link",
                component: Link,
                options: {
                  icon: ["fal", "rectangle-landscape"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        // backgroundColor: "#2f862d",
                      },
                      borderRadius: {
                        lt: 8,
                        rt: 8,
                        lb: 8,
                        rb: 8,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      linkLabel: "Active Button",
                      type: "active",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    linkSettings: true,
                    buttonlabelSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Button",
                icon: ["fal", "rectangle-landscape"],
                id: "button_8",
                type: "link",
                component: Link,
                options: {
                  icon: ["fal", "rectangle-landscape"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2d7286",
                      },
                      borderRadius: {
                        lt: 25,
                        rt: 25,
                        lb: 25,
                        rb: 25,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      linkLabel: "Regular Button",
                      useIcon: true,
                      iconPosition: "left",
                      iconClass: "fa-cart-plus",
                      type: "regular",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    linkSettings: true,
                    buttonlabelSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Button",
                icon: ["fal", "rectangle-landscape"],
                id: "button_9",
                type: "link",
                component: Link,
                options: {
                  icon: ["fal", "rectangle-landscape"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      borderRadius: {
                        lt: 25,
                        rt: 25,
                        lb: 25,
                        rb: 25,
                        unity: "px",
                      },
                      text: {
                        color: "#862d2e",
                      },
                      border: {
                        borderBottom_style: "solid",
                        borderBottom_width: 2,
                        borderBottom_color: "#862d2e",
                        borderRight_style: "solid",
                        borderRight_width: 2,
                        borderRight_color: "#862d2e",
                        borderTop_style: "solid",
                        borderTop_width: 2,
                        borderTop_color: "#862d2e",
                        borderLeft_width: 2,
                        borderLeft_style: "solid",
                        borderLeft_color: "#862d2e",
                      },
                    },
                    datas: {
                      linkLabel: "Active Button",
                      useIcon: true,
                      iconPosition: "right",
                      iconClass: "fa-angle-right",
                      type: "active",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    linkSettings: true,
                    buttonlabelSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
            ],
          },
          {
            title: "Scarcity",
            items: [
              {
                name: "Countdown Line",
                icon: ["fal", "exclamation-triangle"],
                id: "product_stock_countdown",
                type: "product_stock_countdown",
                component: ProductStockCountdown,
                options: {
                  icon: ["fal", "exclamation-triangle"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      labelCountDown: "Only %% seconds left",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      title: "Label style",
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productStockCountdownSettings: true,
                    productStockCountdownColors: true,
                  },
                },
              },
              {
                name: "Countdown Timer",
                icon: ["fal", "text"],
                id: "product_countdown_timer",
                type: "product_countdown_timer",
                component: ProductCountdownTimer,
                options: {
                  icon: ["fal", "text"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      alignment: "center",
                      timerBgColor: "#3b5998",
                      timerColor: "#FFFFFF",
                    },
                    datas: {
                      timerDisplay: {
                        hours: true,
                        minutes: true,
                        seconds: true,
                      },

                      timerShape: "square",
                      timerSize: "medium",
                      timerTarget: "-1",
                      timerHour: 10,
                      timerMinute: 10,
                      timerSecond: 10,
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      title: "Timer text style",
                      color: false,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: false,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productCountDownTimerSettings: true,
                  },
                },
              },
              {
                name: "Product's Viewers",
                icon: ["fal", "eye"],
                id: "product_viewers",
                type: "product_viewers",
                component: ProductViewers,
                options: {
                  icon: ["fal", "eye"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      viewersLabel: "People are viewing this product now.",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productViewersSettings: true,
                  },
                },
              },
              {
                name: "FB Checkbox",
                icon: ["fal", "check-square"],
                id: "fb_checkbox",
                type: "fb_checkbox",
                component: FBCheckbox,
                options: {
                  icon: ["fal", "check-square"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    globalSettings: ["EZSCONF_FB_APP_ID", "EZSCONF_FB_PAGE_ID"],
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Product Elements",
        id: "product",
        groups: [
          {
            title: "Media",
            items: [
              {
                name: "Product's Pictures",
                icon: ["fal", "images"],
                id: "product_pictures",
                type: "product_pictures",
                component: ProductPictures,
                options: {
                  icon: ["fal", "images"],
                  product: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    productPicturesSettings: true,
                  },
                },
              },
              {
                name: "Video",
                icon: ["fal", "play-circle"],
                id: "product_video",
                type: "product_video",
                component: Video,
                options: {
                  icon: ["fal", "play-circle"],
                  product: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: false,
                    videoDimensions: true,
                    videoSource: true,
                  },
                },
              },
            ],
          },
          {
            title: "Content",
            items: [
              {
                name: "Product's Title",
                icon: ["fal", "text"],
                id: "product_title",
                type: "product_title",
                component: ProductTitle,
                options: {
                  icon: ["fal", "text"],
                  product: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      titleTag: "h1",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                    productTitleSettings: true,
                  },
                },
              },
              {
                name: "Product's Summary Description",
                icon: ["fal", "text"],
                id: "product_description_short",
                type: "product_description",
                component: ProductDescription,
                options: {
                  icon: ["fal", "text"],
                  description: "short",
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                  },
                },
              },
              {
                name: "Product's Description",
                icon: ["fal", "text"],
                id: "product_description",
                type: "product_description",
                component: ProductDescription,
                options: {
                  icon: ["fal", "text"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                  },
                },
              },
            ],
          },
          {
            title: "Cart & Pricing",
            items: [
              {
                name: "Product's Pricing",
                icon: ["fal", "tag"],
                id: "product_pricing",
                type: "product_pricing",
                component: ProductPricing,
                options: {
                  icon: ["fal", "tag"],
                  payload: {
                    fullContainer: true,
                    dropped: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      productPricingSettings: {
                        labelBeforeOldPrice: "WAS",
                        labelBeforeCurrentPrice: "NOW",
                        currentPriceFontSize: 30,
                        currentPriceLabelFontSize: 30,
                        // oldPriceColor: "#b71010",
                        // oldPriceFontFamilyId: 12,
                        // oldPriceFontFamily: '"Roboto", sans-serif',
                        // oldPriceFontWeight: 500,
                        oldPriceFontSize: 30,
                        // currentPriceFontFamilyId: 11,
                        // currentPriceFontFamily: '"Roboto", sans-serif',
                        // currentPriceFontWeight: 500,
                        // oldPriceLabelColor: "#323232",
                        // oldPriceLabelFontFamilyId: 11,
                        // oldPriceLabelFontFamily: '"Roboto", sans-serif',
                        oldPriceLabelFontSize: 30,
                        // currentPriceLabelFontFamilyId: 11,
                        // currentPriceLabelFontFamily: '"Roboto", sans-serif',
                        // currentPriceLabelFontWeight: 500,
                        // currentPriceLabelColor: "#323232",
                        // oldPriceLabelFontWeight: 500,
                        // currentPriceColor: "#2d8630",
                      },
                      showInline: true,
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    inlineSettings: true,
                    oldProductPricingSettings: true,
                    currentProductPricingSettings: true,
                    oldProductPricingLabelSettings: true,
                    currentProductPricingLabelSettings: true,
                  },
                },
              },
              {
                name: "Instant Checkout",
                icon: ["fad", "credit-card-front"],
                id: "product_instant_checkout",
                type: "product_instant_checkout",
                component: ProductInstantCheckout,
                options: {
                  icon: ["fad", "credit-card-front"],
                  product: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      ICbuttonLabel: "Add to Cart",
                      ICbuttonBgColor: "#33862d",
                      ICbuttonColor: "#fff",
                    },
                  },
                  settings: {
                    // Settings capability
                    // message: {
                    //   type: "warning",
                    //   content:
                    //     "Product Page Checkout form is NOT working with PayPal.",
                    // },
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: false,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: false,
                      letterSpacing: false,
                      lineHeight: false,
                    },
                    productInstantCheckoutSettings: true,
                  },
                },
              },
              {
                name: "Quantity Selector",
                icon: ["fad", "sliders-v-square"],
                id: "product_quantity",
                type: "product_quantity",
                component: ProductQuantity,
                options: {
                  icon: ["fad", "sliders-v-square"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      currentDesign: 5,
                      QtyLabel: "Order",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      title: "Label style",
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: false,
                      lineHeight: false,
                    },
                    productQuantitySettings: true,
                    designSettings: 5,
                  },
                },
              },
              {
                name: "Product's Variations",
                icon: ["fad", "sliders-v-square"],
                id: "product_attributes",
                type: "product_attributes",
                component: ProductAttributes,
                options: {
                  icon: ["fad", "sliders-v-square"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      currentDesign: 1,
                      variationsLabelColor: "#000000",
                      variationsBgColor: "#ffc0cb",
                      variationsColor: "#000000",
                      variationsBgColorHover: "#0563af",
                      variationsColorHover: "#000000",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      title: "Labels style",
                      color: false,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: false,
                      lineHeight: false,
                    },
                    designSettings: 2,
                    variationSettings: true,
                  },
                },
              },
              {
                name: "Bump Product",
                icon: ["fal", "list"],
                id: "product_bump",
                type: "product_bump",
                component: ProductBump,
                options: {
                  icon: ["fal", "list"],
                  product: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      title: "Font style",
                      color: false,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: false,
                      lineHeight: false,
                    },
                  },
                },
              },
              {
                name: "Bundle Product",
                icon: ["fad", "dollar-sign"],
                id: "product_bundle",
                type: "product_bundle",
                component: ProductBundle,
                options: {
                  icon: ["fad", "dollar-sign"],
                  product: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      showScratchAndWin: false,
                      showProductPrices: true,
                      productPriceBgColor: "#bf4098",
                      productPriceColor: "#FFF",
                      showReductionLabel: true,
                      reductionLabel: "SAVE %REDUCTION_PRICE%",
                      showAddToCart: true,
                      addToCartLabel01: "GET NOW",
                      addToCartBgColor: "#31862d",
                      addToCartLabel02: "THIS OFFER",
                      // reductionLabelBgColor: "#aa40bf",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      title: "Product name style",
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productBundlePrices: true,
                    productBundleReductionAlert: true,
                    productBundleATC: true,
                  },
                },
              },
              {
                name: "Quantity Discount",
                icon: ["fad", "percent"],
                id: "product_quantity_discounts",
                type: "product_quantity_discounts",
                component: ProductQuantityDiscounts,
                options: {
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      showBorderQD: false,
                      tableBorderColorQD: "#888",
                      tableHeadColorQD: "#FFF",
                      tableHeadBgColorQD: "#888",
                      tableEvenRowBgColorQD: "#EDEDED",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    // text: {
                    //   title: "Font Settings",
                    //   color: false,
                    //   textAlign: false,
                    //   fontFamily: true,
                    //   fontSize: false,
                    //   letterSpacing: false,
                    //   lineHeight: false,
                    // },
                    qtyDiscounts: true,
                  },
                },
              },
            ],
          },
          {
            title: "Add to Cart Buttons",
            items: [
              {
                name: "Add to Cart",
                icon: ["fal", "cart-plus"],
                id: "product_add_to_cart_14",
                type: "product_add_to_cart",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2f862d",
                      },
                      borderRadius: {
                        lt: 25,
                        rt: 25,
                        lb: 25,
                        rb: 25,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Add to cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Add to Cart",
                icon: ["fal", "cart-plus"],
                id: "product_add_to_cart_1",
                type: "product_add_to_cart",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2d3386",
                      },
                      borderRadius: {
                        lt: 0,
                        rt: 0,
                        lb: 0,
                        rb: 0,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                        fontSize: 16,
                        letterSpacing: 0,
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Add to Cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Add to Cart",
                icon: ["fal", "cart-plus"],
                id: "product_add_to_cart_5",
                type: "product_add_to_cart",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2d3186",
                      },
                      borderRadius: {
                        lt: 0,
                        rt: 0,
                        lb: 0,
                        rb: 0,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Add to Cart",
                      useIcon: true,
                      iconPosition: "right",
                      iconClass: "fa-shopping-cart",
                      searchIcon: "cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
            ],
          },
          {
            title: "Other",
            items: [
              {
                name: "Related Products",
                icon: ["fal", "shopping-bag"],
                id: "product_related_products",
                type: "product_related_products",
                component: RelatedProducts,
                options: {
                  icon: ["fal", "shopping-bag"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        textAlign: "center",
                      },
                    },
                    datas: {
                      // cpColor01: "#f042a8",
                      // cpColor02: "#f3b200",
                      // cpColor03: "#000",
                      relProductsPerRowLg: 3,
                      relProductsPerRowMd: 4,
                      relProductsPerRowSm: 4,
                      relProductsPerRowXs: 6,
                      atclabel: "Add to cart",
                      titleTag: "h4",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: false,
                      lineHeight: false,
                    },
                    relatedProducts: true,
                    // designSettings: 6,
                    atcStyling: true,
                    imageCss: true,
                    starStyle: true,
                    priceStyle: true,
                    productTitleSettings: true,
                  },
                },
              },
              {
                name: "Product's Reviews",
                icon: ["fal", "comment-smile"],
                id: "product_reviews",
                type: "product_reviews",
                component: ProductReviews,
                options: {
                  icon: ["fal", "comment-smile"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      currentDesign: 1,
                      custom_color: "#f042a8",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    // text: {
                    //   title: "Labels text style",
                    //   color: false,
                    //   textAlign: true,
                    //   fontFamily: true,
                    //   fontSize: false,
                    //   letterSpacing: false,
                    //   lineHeight: false,
                    // },
                    productReviewSettings: true,
                    productReviewColors: true,
                    designSettings: 5,
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Cart Elements",
        id: "shoppingcart",
        groups: [
          {
            title: "Table",
            items: [
              {
                name: "Summary Table",
                icon: ["fal", "shopping-basket"],
                id: "summary",
                type: "summary",
                component: Summary,
                options: {
                  icon: ["fal", "shopping-basket"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      showProductPicture: true,
                      showProductAttribute: true,
                      showRemoveProductButton: true,
                      showChangeQtyAbility: true,
                      showCartExpiringTimer: true,
                      tableHeadBgColor: "",
                      productNameColor: "#000000",
                      productAttributesColor: "#232d3b",
                      removeButtonTextColor: "#000000",
                      removeButtonBackgroundColor: "#c4cfec",
                      tableFootColor: "#000000",
                      cartExpiringTimerColor: "#cb3228",
                      priceTotalColor: "#f042a8",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    // text: {
                    //   color: false,
                    //   textAlign: false,
                    //   fontFamily: true,
                    //   fontSize: false,
                    //   letterSpacing: false,
                    //   lineHeight: false,
                    // },
                    // summaryDisplaySettings: false,
                    // summaryStyling: false,
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Category Elements",
        id: "category",
        groups: [
          {
            title: "Content",
            items: [
              {
                name: "Category Title",
                icon: ["fal", "text"],
                id: "category_title",
                type: "category_title",
                component: CategoryTitle,
                options: {
                  icon: ["fal", "text"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      titleTag: "h1",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                    productTitleSettings: true,
                  },
                },
              },
              {
                name: "Category Description",
                icon: ["fal", "text"],
                id: "category_description",
                type: "category_description",
                component: CategoryDescription,
                options: {
                  icon: ["fal", "text"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    // text: {
                    //   color: true,
                    //   textAlign: true,
                    //   fontFamily: true,
                    //   fontSize: true,
                    //   letterSpacing: true,
                    //   lineHeight: true,
                    // },
                  },
                },
              },
            ],
          },
          {
            title: "Media",
            items: [
              {
                name: "Category Image",
                icon: ["fal", "images"],
                id: "category_image",
                type: "category_image",
                component: CategoryImage,
                options: {
                  icon: ["fal", "images"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      alignment: "center",
                      datas: {
                        imageHeight: 200,
                        imageWidth: 200,
                        displayMode: "ratio",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: false,
                    imageSettings: true,
                  },
                },
              },
            ],
          },
          {
            title: "Products",
            items: [
              {
                name: "Category Products",
                icon: ["fal", "shopping-bag"],
                id: "category_products",
                type: "category_products",
                component: CategoryProducts,
                options: {
                  icon: ["fal", "shopping-bag"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        textAlign: "center",
                      },
                    },
                    datas: {
                      // currentDesign: 1,
                      // cpColor01: "#f042a8",
                      // cpColor02: "#f3b200",
                      // cpColor03: "#000",
                      atclabel: "Add to cart",
                      atcbc: "#33862d",
                      atcc: "#ffffff",
                      showProductSorting: true,
                      showPaginationSummary: true,
                      relProductsPerRowLg: 3,
                      relProductsPerRowMd: 4,
                      relProductsPerRowSm: 4,
                      relProductsPerRowXs: 6,
                      titleTag: "h4",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    // text: false,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: false,
                      fontSize: true,
                      letterSpacing: false,
                      lineHeight: false,
                    },
                    categoryProducts: true,
                    // designSettings: 6,
                    atcStyling: true,
                    imageCss: true,
                    starStyle: true,
                    priceStyle: true,
                    productTitleSettings: true,
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Brand Elements",
        id: "manufacturer",
        groups: [
          {
            title: "Content",
            items: [
              {
                name: "Brand Title",
                icon: ["fal", "text"],
                id: "brand_title",
                type: "brand_title",
                component: BrandTitle,
                options: {
                  icon: ["fal", "text"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      titleTag: "h1",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                    productTitleSettings: true,
                  },
                },
              },
              {
                name: "Brand Description",
                icon: ["fal", "text"],
                id: "brand_description",
                type: "brand_description",
                component: BrandDescription,
                options: {
                  icon: ["fal", "text"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    // text: {
                    //   color: true,
                    //   textAlign: true,
                    //   fontFamily: true,
                    //   fontSize: true,
                    //   letterSpacing: true,
                    //   lineHeight: true,
                    // },
                  },
                },
              },
            ],
          },
          {
            title: "Media",
            items: [
              {
                name: "Brand Image",
                icon: ["fal", "images"],
                id: "brand_image",
                type: "brand_image",
                component: BrandImage,
                options: {
                  icon: ["fal", "images"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      alignment: "center",
                      datas: {
                        imageHeight: 200,
                        imageWidth: 200,
                        displayMode: "ratio",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: false,
                    imageSettings: true,
                  },
                },
              },
            ],
          },
          {
            title: "Products",
            items: [
              {
                name: "Brand Products",
                icon: ["fal", "shopping-bag"],
                id: "brand_products",
                type: "brand_products",
                component: BrandProducts,
                options: {
                  icon: ["fal", "shopping-bag"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        textAlign: "center",
                      },
                    },
                    datas: {
                      // currentDesign: 1,
                      // cpColor01: "#f042a8",
                      // cpColor02: "#f3b200",
                      // cpColor03: "#000",
                      atclabel: "Add to cart",
                      atcbc: "#33862d",
                      atcc: "#ffffff",
                      showProductSorting: true,
                      showPaginationSummary: true,
                      relProductsPerRowLg: 3,
                      relProductsPerRowMd: 4,
                      relProductsPerRowSm: 4,
                      relProductsPerRowXs: 6,
                      titleTag: "h4",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    // text: false,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: false,
                      fontSize: true,
                      letterSpacing: false,
                      lineHeight: false,
                    },
                    categoryProducts: true,
                    // designSettings: 6,
                    atcStyling: true,
                    imageCss: true,
                    starStyle: true,
                    priceStyle: true,
                    productTitleSettings: true,
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Checkout Elements",
        id: "checkout",
        groups: [
          {
            title: "Table",
            items: [
              {
                name: "Steps",
                icon: ["fal", "step-forward"],
                id: "checkout_steps",
                type: "checkout_steps",
                component: CheckoutSteps,
                options: {
                  icon: ["fal", "step-forward"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      nextStepBackgroundColor: "#eeeeee",
                      previousStepBackgroundColor: "#f042a8",
                      currentStepBackgroundColor: "#4370a4",
                      nextStepTextColor: "#000000",
                      previousStepTextColor: "#ffffff",
                      currentStepTextColor: "#ffffff",
                    },
                    datas: {},
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: false,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    previousStepSettings: true,
                    currentStepSettings: true,
                    nextStepSettings: true,
                  },
                },
              },
              {
                name: "Summary",
                icon: ["fal", "shopping-cart"],
                id: "checkout_summary",
                type: "checkout_summary",
                component: CheckoutSummary,
                options: {
                  icon: ["fal", "shopping-cart"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      priceColor: "#f042a8",
                      tableBgColor: "#fafafa",
                      tableBorderColor: "#cccccc",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                    checkoutSummaryStyling: true,
                    globalSettings: ["EZCONF_SHOW_INSTANT_DISCOUNT"],
                  },
                },
              },
            ],
          },
          {
            title: "Form",
            items: [
              {
                name: "Checkout Form",
                icon: ["fad", "credit-card-front"],
                id: "checkout_form",
                type: "checkout_form",
                component: CheckoutForm,
                options: {
                  icon: ["fad", "credit-card-front"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      nextStepBackgroundColor: "#eeeeee",
                      previousStepBackgroundColor: "#f042a8",
                      currentStepBackgroundColor: "#4370a4",
                      nextStepTextColor: "#000000",
                      previousStepTextColor: "#ffffff",
                      currentStepTextColor: "#ffffff",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                    globalSettings: [
                      "GK_ONEPAGE_CHECKOUT",
                      "EZCONF_SHOW_PH_NUMBER_DISPLAY",
                      "EZCONF_SHOW_PH_NUMBER_REQUIRED",
                      "SHOW_CHECKOUT_ORDER_NOTE",
                      "SHOW_CHECKOUT_ORDER_NOTE_REQUIRE",
                      "EZSCONF_PRECHECK_OPTIONS",
                      "EZCONF_SHOW_CREATE_ACCOUNT",
                      "EZCONF_SHOW_NEWSLETTER",
                      "EZSCONF_SET_CHECKBOXES_POSITION",
                      "GK_PRICE_AFTER_TEXT",
                      "GK_PAYMENT_TEXT",
                      "GK_CHECKOUT_MOBILE_ACTIVE",
                      "GK_CHECKOUT_EMAIL_ACTIVE",
                      "GK_TWILIO_ACCOUNT_SID",
                      "GK_TWILIO_AUTH_TOKEN",
                      "GK_TWILIO_PHONE_NUMBER",
                    ],
                    previousStepSettings: true,
                    currentStepSettings: true,
                    nextStepSettings: true,
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Upsell Elements",
        id: "upsell",
        groups: [
          {
            title: "Product Elements",
            items: [
              {
                name: "Product's Title",
                icon: ["fal", "text"],
                id: "upsell_product_title",
                type: "upsell_product_title",
                component: ProductTitle,
                options: {
                  icon: ["fal", "text"],
                  product: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: true,
                    },
                    productTitleSettings: true,
                  },
                },
              },
              {
                name: "Product's Summary Description",
                icon: ["fal", "text"],
                id: "upsell_product_description_short",
                type: "upsell_product_description",
                component: ProductDescription,
                options: {
                  icon: ["fal", "text"],
                  description: "short",
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                  },
                },
              },
              {
                name: "Product's Description",
                icon: ["fal", "text"],
                id: "upsell_product_description",
                type: "upsell_product_description",
                component: ProductDescription,
                options: {
                  icon: ["fal", "text"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                  },
                },
              },
              {
                name: "Product's Upsell Description",
                icon: ["fal", "text"],
                id: "upsell_product_upsell_description",
                type: "upsell_product_upsell_description",
                component: ProductUpsellDescription,
                options: {
                  icon: ["fal", "text"],
                  description: "short",
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    // text: {
                    //   color: true,
                    //   textAlign: true,
                    //   fontFamily: true,
                    //   fontSize: true,
                    //   letterSpacing: true,
                    //   lineHeight: true,
                    // },
                  },
                },
              },
              {
                name: "Product's Pictures",
                icon: ["fal", "images"],
                id: "upsell_product_pictures",
                type: "upsell_product_pictures",
                component: ProductPictures,
                options: {
                  icon: ["fal", "images"],
                  product: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      thumbnailsPosition: "bottom",
                      showThumbnails: false,
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    productPicturesSettings: true,
                  },
                },
              },
              {
                name: "Product's Reviews",
                icon: ["fal", "comment-smile"],
                id: "upsell_product_reviews",
                type: "upsell_product_reviews",
                component: ProductReviews,
                options: {
                  icon: ["fal", "comment-smile"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      currentDesign: 1,
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      title: "Labels text style",
                      color: false,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: false,
                      letterSpacing: false,
                      lineHeight: false,
                    },
                    productReviewSettings: true,
                    productReviewColors: true,
                    designSettings: 5,
                  },
                },
              },
              {
                name: "Product's Pricing",
                icon: ["fal", "tag"],
                id: "upsell_product_pricing",
                type: "upsell_product_pricing",
                component: ProductPricing,
                options: {
                  icon: ["fal", "tag"],
                  payload: {
                    fullContainer: true,
                    dropped: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      productPricingSettings: {
                        labelBeforeOldPrice: "OLD PRICE",
                        labelBeforeCurrentPrice: "FINAL PRICE",
                        currentPriceFontSize: 26,
                        currentPriceLabelFontSize: 26,
                        // oldPriceColor: "#b71010",
                        // oldPriceFontFamilyId: 11,
                        // oldPriceFontFamily: '"Roboto", sans-serif',
                        // oldPriceFontWeight: 500,
                        oldPriceFontSize: 26,
                        // currentPriceFontFamilyId: 11,
                        // currentPriceFontFamily: '"Roboto", sans-serif',
                        // currentPriceFontWeight: 500,
                        // oldPriceLabelColor: "#323232",
                        // oldPriceLabelFontFamilyId: 11,
                        // oldPriceLabelFontFamily: '"Roboto", sans-serif',
                        oldPriceLabelFontSize: 26,
                        // currentPriceLabelFontFamilyId: 11,
                        // currentPriceLabelFontFamily: '"Roboto", sans-serif',
                        // currentPriceLabelFontWeight: 500,
                        // currentPriceLabelColor: "#323232",
                        // oldPriceLabelFontWeight: 500,
                        // currentPriceColor: "#000000",
                      },
                      showInline: true,
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: false,
                    inlineSettings: true,
                    oldProductPricingSettings: true,
                    currentProductPricingSettings: true,
                    oldProductPricingLabelSettings: true,
                    currentProductPricingLabelSettings: true,
                  },
                },
              },
              {
                name: "Product's Variations",
                icon: ["fad", "sliders-v-square"],
                id: "upsell_product_attributes",
                type: "upsell_product_attributes",
                component: ProductAttributes,
                options: {
                  icon: ["fad", "sliders-v-square"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      currentDesign: 1,
                      variationsLabelColor: "#000000",
                      variationsBgColor: "#ffc0cb",
                      variationsColor: "#000000",
                      variationsBgColorHover: "#0563af",
                      variationsColorHover: "#000000",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      title: "Labels style",
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: false,
                      letterSpacing: false,
                      lineHeight: false,
                    },
                    designSettings: 2,
                    variationSettings: true,
                  },
                },
              },
              {
                name: "Quantity Selector",
                icon: ["fad", "sliders-v-square"],
                id: "upsell_product_quantity",
                type: "upsell_product_quantity",
                component: ProductQuantity,
                options: {
                  icon: ["fad", "sliders-v-square"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      currentDesign: 5,
                      QtyLabel: "Order",
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      title: "Label style",
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: false,
                      lineHeight: false,
                    },
                    productQuantitySettings: true,
                    designSettings: 5,
                  },
                },
              },
            ],
          },
          {
            title: "Add to Cart Buttons",
            items: [
              {
                name: "Add to Cart",
                icon: ["fal", "cart-plus"],
                id: "upsell_add_to_cart_14",
                type: "upsell_add_to_cart",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2f862d",
                      },
                      borderRadius: {
                        lt: 25,
                        rt: 25,
                        lb: 25,
                        rb: 25,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Add to Cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Add to Cart",
                icon: ["fal", "cart-plus"],
                id: "upsell_add_to_cart_5",
                type: "upsell_add_to_cart",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2d3186",
                      },
                      borderRadius: {
                        lt: 0,
                        rt: 0,
                        lb: 0,
                        rb: 0,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Add to Cart",
                      useIcon: true,
                      iconPosition: "right",
                      iconClass: "fa-shopping-cart",
                      searchIcon: "cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
            ],
          },
          {
            title: "No Thank You Buttons",
            items: [
              {
                name: "No thank you Button",
                icon: ["fal", "cart-plus"],
                id: "upsell_nothankyou_14",
                type: "upsell_nothankyou",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2f862d",
                      },
                      borderRadius: {
                        lt: 25,
                        rt: 25,
                        lb: 25,
                        rb: 25,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "No thank you",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },

              {
                name: "No thank you Button",
                icon: ["fal", "cart-plus"],
                id: "upsell_nothankyou_5",
                type: "upsell_nothankyou",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2d3186",
                      },
                      borderRadius: {
                        lt: 0,
                        rt: 0,
                        lb: 0,
                        rb: 0,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "No thank you",
                      useIcon: true,
                      iconPosition: "right",
                      iconClass: "fa-shopping-cart",
                      searchIcon: "cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
            ],
          },
          {
            title: "Other",
            items: [
              {
                name: "Total cart price",
                icon: ["fal", "text"],
                id: "upsell_total_cart_price",
                type: "upsell_total_cart_price",
                component: ProductUpsellTotalCartPrice,
                options: {
                  icon: ["fal", "text"],
                  description: "short",
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                    },
                    datas: {
                      cartPriceLabel: "Lorem ipsum %% dolor sit amet",
                      cartPriceColor: "#a94442",
                      totalCart_product: true,
                      totalCart_shipping: true,
                      totalCart_tax: true,
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: true,
                    alignment: false,
                    border: true,
                    corners: true,
                    spacing: true,
                    text: {
                      title: "Label style",
                      color: true,
                      textAlign: true,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    totalCartPrice: true,
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Flyout Cart Elements",
        id: "flyoutcart",
        groups: [
          {
            title: "Main elements",
            items: [
              {
                name: "Summary",
                icon: ["fal", "shopping-basket"],
                id: "flyoutcart_summary",
                type: "flyoutcart_summary",
                component: FlyoutCartSummary,
                options: {
                  icon: ["fal", "shopping-basket"],
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                    },
                  },
                  settings: {
                    // Settings capability
                    opacity: true,
                    background: false,
                    alignment: false,
                    border: false,
                    corners: false,
                    spacing: true,
                    text: false,
                  },
                  datas: {
                    showProductPicture: true,
                    showProductAttribute: true,
                    showRemoveProductButton: true,
                    showChangeQtyAbility: true,
                    productNameColor: "#000000",
                    productAttributesColor: "#232d3b",
                    removeButtonTextColor: "#000000",
                    removeButtonBackgroundColor: "#c4cfec",
                    priceTotalColor: "#f042a8",
                  },
                },
              },
            ],
          },
          {
            title: "Proceed to checkout Buttons",
            items: [
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_14",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2f862d",
                      },
                      borderRadius: {
                        lt: 25,
                        rt: 25,
                        lb: 25,
                        rb: 25,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_1",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2d3386",
                      },
                      borderRadius: {
                        lt: 0,
                        rt: 0,
                        lb: 0,
                        rb: 0,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                        fontSize: 16,
                        letterSpacing: 0,
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_2",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#bf4094",
                      },
                      borderRadius: {
                        lt: 6,
                        rt: 6,
                        lb: 6,
                        rb: 6,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_3",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#bfa740",
                      },
                      borderRadius: {
                        lt: 14,
                        rt: 14,
                        lb: 14,
                        rb: 14,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                      border: {
                        borderBottom_color: "#86019b",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_4",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#6d2d86",
                      },
                      borderRadius: {
                        lt: 25,
                        rt: 25,
                        lb: 25,
                        rb: 25,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_5",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2d3186",
                      },
                      borderRadius: {
                        lt: 0,
                        rt: 0,
                        lb: 0,
                        rb: 0,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                      useIcon: true,
                      iconPosition: "right",
                      iconClass: "fa-shopping-cart",
                      searchIcon: "cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_6",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#822d86",
                      },
                      borderRadius: {
                        lt: 6,
                        rt: 6,
                        lb: 6,
                        rb: 6,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                      useIcon: true,
                      iconPosition: "right",
                      iconClass: "fa-opencart",
                      searchIcon: "cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_7",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 10,
                        paddingBottom: 10,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#86382d",
                      },
                      borderRadius: {
                        lt: 14,
                        rt: 14,
                        lb: 14,
                        rb: 14,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                      useIcon: true,
                      iconPosition: "left",
                      iconClass: "fa-cart-plus",
                      searchIcon: "cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_8",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                        backgroundColor: "#2d7286",
                      },
                      borderRadius: {
                        lt: 25,
                        rt: 25,
                        lb: 25,
                        rb: 25,
                        unity: "px",
                      },
                      text: {
                        color: "#FFF",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                      useIcon: true,
                      iconPosition: "left",
                      iconClass: "fa-cart-plus",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_9",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      borderRadius: {
                        lt: 25,
                        rt: 25,
                        lb: 25,
                        rb: 25,
                        unity: "px",
                      },
                      text: {
                        color: "#862d2e",
                      },
                      border: {
                        borderBottom_style: "solid",
                        borderBottom_width: 2,
                        borderBottom_color: "#862d2e",
                        borderRight_style: "solid",
                        borderRight_width: 2,
                        borderRight_color: "#862d2e",
                        borderTop_style: "solid",
                        borderTop_width: 2,
                        borderTop_color: "#862d2e",
                        borderLeft_width: 2,
                        borderLeft_style: "solid",
                        borderLeft_color: "#862d2e",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                      useIcon: true,
                      iconPosition: "right",
                      iconClass: "fa-angle-right",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_10",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      borderRadius: {
                        lt: 0,
                        rt: 0,
                        lb: 0,
                        rb: 0,
                        unity: "px",
                      },
                      text: {
                        color: "#342d86",
                        fontSize: "16",
                      },
                      border: {
                        borderBottom_style: "solid",
                        borderBottom_width: 2,
                        borderBottom_color: "#01249b",
                        borderRight_style: "solid",
                        borderRight_width: 2,
                        borderRight_color: "#01249b",
                        borderTop_style: "solid",
                        borderTop_width: 2,
                        borderTop_color: "#01249b",
                        borderLeft_width: 2,
                        borderLeft_style: "solid",
                        borderLeft_color: "#01249b",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_11",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      borderRadius: {
                        lt: 14,
                        rt: 14,
                        lb: 14,
                        rb: 14,
                        unity: "px",
                      },
                      text: {
                        color: "#000",
                        fontStyle: "normal",
                        fontFamilyId: 11,
                        fontFamily: '"Roboto", sans-serif',
                      },
                      border: {
                        borderBottom_style: "solid",
                        borderBottom_width: 2,
                        borderBottom_color: "#000",
                        borderRight_style: "solid",
                        borderRight_width: 2,
                        borderRight_color: "#000",
                        borderTop_style: "solid",
                        borderTop_width: 2,
                        borderTop_color: "#000",
                        borderLeft_width: 2,
                        borderLeft_style: "solid",
                        borderLeft_color: "#000",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                      useIcon: true,
                      iconPosition: "right",
                      iconClass: "fa-chevron-circle-right",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_12",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "cart-plus"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                        paddingTop: 15,
                        paddingBottom: 15,
                        paddingLeft: 30,
                        paddingRight: 30,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      borderRadius: {
                        lt: 6,
                        rt: 6,
                        lb: 6,
                        rb: 6,
                        unity: "px",
                      },
                      text: {
                        color: "#862d84",
                      },
                      border: {
                        borderBottom_style: "dashed",
                        borderBottom_width: 2,
                        borderBottom_color: "#9b016f",
                        borderRight_style: "dashed",
                        borderRight_width: 2,
                        borderRight_color: "#9b016f",
                        borderTop_style: "dashed",
                        borderTop_width: 2,
                        borderTop_color: "#9b016f",
                        borderLeft_width: 2,
                        borderLeft_style: "dashed",
                        borderLeft_color: "#9b016f",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                      useIcon: true,
                      iconPosition: "right",
                      iconClass: "fa-opencart",
                      searchIcon: "cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
              {
                name: "Proceed to checkout",
                icon: ["fal", "cart-plus"],
                id: "proceedtocheckout_13",
                type: "proceedtocheckout",
                component: ProductAddToCart,
                options: {
                  icon: ["fal", "rectangle-landscape"],
                  showPreview: true,
                  payload: {
                    fullContainer: true,
                    settings: {
                      spacing: {
                        marginBottom: 10,
                      },
                      background: {
                        backgroundSize: "cover",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center center",
                      },
                      text: {
                        color: "#fd6481",
                      },
                    },
                    datas: {
                      ATCbuttonLabel: "Proceed to checkout",
                      useIcon: true,
                      iconPosition: "right",
                      iconClass: "fa-shopping-cart",
                      searchIcon: "cart",
                    },
                  },
                  settings: {
                    // Settings capability
                    background: true,
                    border: true,
                    corners: true,
                    spacing: true,
                    alignment: true,
                    text: {
                      color: true,
                      textAlign: false,
                      fontFamily: true,
                      fontSize: true,
                      letterSpacing: true,
                      lineHeight: false,
                    },
                    productATCSettings: true,
                    iconSettings: true,
                    buttonAnimation: true,
                    buttonWidth: true,
                  },
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Pages",
    sideTitle: "Menu & Pages",
    id: "pages",
    icon: "pages",
  },
  {
    title: "Themes",
    sideTitle: "Themes",
    id: "themes",
    icon: "theme",
  },

  {
    title: "Page Settings",
    sideTitle: "Page Settings",
    id: "pageSettings",
    icon: "settings",
  },
];

const rightPalettes = [
  {
    title: 'Themes',
    sideTitle: 'Themes',
    id: 'themes',
    icon: ['fad', 'layer-group'],
  },
];

export { leftPalettes, rightPalettes };
